<template>
  <div>
    <a-card
      style="width:100%"
      :tabList="tabListNoTitle"
      :activeTabKey="noTitleKey"
      @tabChange="key => onTabChange(key, 'noTitleKey')"
    >
      <div v-if="noTitleKey === 'articleManagement'">
        <div class="form-container">
          <a-select
            style="width: 240px;margin-right:60px"
            @change="handleChange"
            :defaultValue="0"
          >
            <a-select-option :value="0">- 全部</a-select-option>
            <a-select-option v-for="item in articleCategoryList" :key="item.id" :value="item.id">- {{ item.name }}
            </a-select-option>
          </a-select>
          <a-input-search placeholder="搜索文章" @search="onSearch" style="width: 500px" enterButton/>
        </div>
        <div class="operation">
          <a-button type="primary" @click="articleSort">排序</a-button>&nbsp;&nbsp;
          <a-button type="danger" :disabled="!hasSelected" @click="deleteGroup">删除</a-button>
        </div>
        <div class="table-container">
          <a-table
            :columns="columns"
            :dataSource="articleListInfo"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            :pagination="pagination"
            @change="handleTableChange"
            rowKey="id"
          >
            <div slot="sort" slot-scope="text, record, index">
              <a-input v-model="text" @change="handleSortChange(record, $event, index)" maxLength="25"/>
            </div>
            <div slot="operation" slot-scope="text, record">
              <a-button class="editBtn" @click="editModel(record)">编辑</a-button>
              <a-button type="danger" @click="showDeleteConfirm(record.id)">删除</a-button>
            </div>
          </a-table>
        </div>
      </div>
      <div v-else-if="noTitleKey === 'addNewArticle'">
        <a-form
          :form="form"
          @submit="handleSubmit"
        >
          <a-form-item
            label="标题"
            :label-col="{ span: 1 }"
            :wrapper-col="{ span: 22 }"
          >
            <a-input
              v-decorator="[
                'title',
                {rules: [{ required: true, message: '请输入标题!' }]}
              ]"
            />
          </a-form-item>
          <a-form-item
            label="分类"
            :label-col="{ span: 1 }"
            :wrapper-col="{ span: 22 }"
          >
            <a-select
              v-decorator="[
                'categroy',
                {rules: [{ required: true, message: '请选择分类!' }]}
              ]"
              placeholder="选择分类"
              @change="handleSelectChange"
            >
              <a-select-option :value="item.id" v-for=" item in addArticleCategoryList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="摘要"
            :label-col="{ span: 1 }"
            :wrapper-col="{ span: 22 }"
          >
            <a-input
              v-decorator="[
                'note',
                {rules: [{ required: true, message: '请写入摘要!' }]}
              ]"
            />
          </a-form-item>
          <a-form-item
          >
            <!-- bidirectional data binding（双向数据绑定） -->
            <quill-editor
              v-model="content"
              class="quill-editor"
              ref="myQuillEditor"
              :options="editorOption"
              @change="onEditorChange($event)"
            >

            </quill-editor>
          </a-form-item>
          <a-form-item
            :wrapper-col="{ span: 5, offset: 2 }"
          >
            <a-button
              type="primary"
              html-type="submit"
              class="submit-style"
            >
              新建
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <EditArticle ref="showModel" @ok="handOk"/>
  </div>
</template>

<script>
// 文章操作表格
import '../../../node_modules/quill/dist/quill.core.css'
import '../../../node_modules/quill/dist/quill.snow.css'
import '../../../node_modules/quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import { getArticleList, getAiticleCategoryList, creatArticle, removeArticle, sortArticle } from '@/api/manage'
import EditArticle from './modules/editArticle'

const columns = [
  {
    title: '排序',
    dataIndex: 'order',
    key: 'order',
    width: '14%',
    scopedSlots: { customRender: 'sort' }
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: '5%'
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
    width: '30%'
  },
  {
    title: '分类',
    dataIndex: 'label',
    key: 'label'
  },
  {
    title: '作者',
    dataIndex: 'creator',
    key: 'creator'
  },
  {
    title: '发布时间',
    dataIndex: 'create_time',
    width: '10%',
    key: 'create_time'
  },
  {
    title: '操作',
    key: 'operation',
    width: '16%',
    scopedSlots: { customRender: 'operation' }
  }
]
export default {
  components: {
    quillEditor,
    EditArticle
  },
  data () {
    return {
      tabListNoTitle: [
        {
          key: 'articleManagement',
          tab: '文章管理'
        },
        {
          key: 'addNewArticle',
          tab: '新增文章  '
        }
      ],
      noTitleKey: 'articleManagement',
      articleCategoryList: [], // 文章分类
      addArticleCategoryList: [],
      categoryLabel: '',
      articleListInfo: [], // 表格数据
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1
      }, // 表格分页
      seleType: 0,
      categoryId: 0, // 新增文章的id
      loading: false, // 加载loading
      // 文章操作表格数据
      columns,
      selectedRowKeys: [],
      pushStatus: false, // 推送状态
      pushMessageVisible: false,

      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      // 富文本数据
      content: '',
      editorOption: {
        // some quill options
      },
      orderArr: []
    }
  },
  // 文章选中计算
  computed: {
    hasSelected () {
      return this.selectedRowKeys.length > 0
    }
  },
  mounted () {
    // 获取文脏那个列表
    // 获取文脏那个分类
    this.getCategoryArticleList()
    this.ArticleList({ page: 1, pageSize: 10, categoryId: 0, title: '' })
  },
  methods: {
    // 头部切换
    onTabChange (key, type) {
      this[type] = key
      if (key === 'articleManagement') {
        this.getCategoryArticleList()
        this.ArticleList({ page: 1, pageSize: 10, categoryId: 0, title: '' })
      }
    },
    // 获取文章列表
    ArticleList (parmas) {
      return getArticleList(parmas)
        .then(res => {
          res.result.list.forEach((val, key) => {
            val.order = val.order ? val.order.toString() : 0
          })
          this.articleListInfo = res.result.list
          this.pagination.total = res.result.total
        })
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    // 获取文章分类
    getCategoryArticleList () {
      return getAiticleCategoryList()
        .then(res => {
          const arr = []
          res.result.forEach((item) => {
            arr.push(item)
            this.articleCategoryList = arr
            this.addArticleCategoryList = arr
            if (item.children) {
              item.children.forEach((item) => {
                arr.push(item)
                this.articleCategoryList = arr
                this.addArticleCategoryList = arr
                if (item.children) {
                  item.children.forEach((item) => {
                    arr.push(item)
                    this.articleCategoryList = arr
                    this.addArticleCategoryList = arr
                  })
                }
              })
            }
          })
        })
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    // 下拉框
    handleChange (value) {
      this.seleType = value
      this.ArticleList({ page: 1, pageSize: 10, categoryId: value, title: '' })
    },
    // 搜索框搜索的内容
    onSearch (value) {
      this.ArticleList({ page: 1, pageSize: 10, categoryId: this.seleType, title: value })
    },
    // 分页数据
    handleTableChange (pagination, filters, sorter) {
      // console.log(pagination)
      this.pagination.current = pagination.current
      this.ArticleList({
        page: pagination.current,
        pageSize: 10,
        categoryId: this.seleType,
        title: ''
      })
    },
    // 文章管理表格选中删除
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      // console.log(this.selectedRowKeys.join(','))
    },
    deleteGroup () {
      const deleteId = this.selectedRowKeys.join(',')
      this.showDeleteConfirm(deleteId)
    },
    showDeleteConfirm (record) {
      this.$confirm({
        title: '是否删除当前文章?',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          return removeArticle({ 'postId': record })
            .then(res => {
              this.$message.success('删除成功')
              this.ArticleList({ page: 1, pageSize: 10, categoryId: this.seleType, title: '' })
            })
            .catch((err) => this.requestFailed(err))
            .finally(() => {
              this.loading = false
            })
        },
        onCancel () {
          // console.log('Cancel')
        }
      })
    },
    editModel (record) {
      this.$refs.showModel.show(record, this.articleCategoryList)
    },
    handOk () {
      this.ArticleList({ page: this.pagination.current, pageSize: 10, categoryId: this.seleType, title: '' })
    },
    // 文本域操作
    onEditorChange ({ quill, html, text }) {
      this.content = html
    },
    // 新增文章form提交
    handleSubmit (e) {
      e.preventDefault()
      if (!this.content) {
        this.$message.error('记得输入内容哦~~~')
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.creatAiticle({
            label: this.categoryLabel,
            title: values.title,
            excerpt: values.note,
            content: this.content,
            category_id: this.categoryId
          })
        }
      })
    },
    // 文章提交
    creatAiticle (parmas) {
      return creatArticle(parmas)
        .then(res => {
          this.$message.success(res.msg)
          this.form.resetFields()
          this.content = ''
        })
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    handleSelectChange (value) {
      this.categoryId = value
      this.addArticleCategoryList.forEach((i) => {
        if (i.id === value) {
          this.categoryLabel = i.name
        }
      })
    },
    requestFailed (err) {
      // console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    },
    handleSortChange (record, e, index) {
      if (e.data) {
        record.order += e.data
      } else {
        record.order = ''
      }
    },
    articleSort () {
      const arr = []
      this.articleListInfo.forEach((i) => {
        var obj = {
          id: i.id,
          order: i.order
        }
        arr.push(obj)
      })
      return sortArticle({ list: JSON.stringify(arr) })
        .then(res => {
          this.$message.success(res.msg)
          this.ArticleList({ page: this.pagination.current, pageSize: 10, categoryId: this.seleType, title: '' })
        })
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="less" scoped>
  .editBtn {
    margin: 0 10px;
  }

  .form-container {
    width: 100%;
    height: 40px;
    margin-bottom: 10px;
  }

  .table-container {
    margin-top: 20px;
  }

  .quill-editor {
    width: 92%;
    height: 400px;
    margin: 0 auto;
  }

  .submit-style {
    margin-top: 80px;
  }
</style>
